import { createFileRoute } from '@tanstack/react-router';
import { NotificationsLayout } from '@/components/admin/notifications/NotificationsLayout.tsx';
import { NotificationsTab } from '@/components/admin/notifications/NotificationsTab.tsx';

export const Route = createFileRoute('/_app/admin/notifications/')({
  staticData: { orgScope: 'optional' },
  component: NotificationsPage,
});

export function NotificationsPage() {
  return (
    <NotificationsLayout active='send'>
      <NotificationsTab />
    </NotificationsLayout>
  );
}
